import { render, staticRenderFns } from "./PreviewStudent.vue?vue&type=template&id=9e335a4c&"
import script from "./PreviewStudent.vue?vue&type=script&lang=js&"
export * from "./PreviewStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports